/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const VerifyMyPhoneResponse = zod.object({
  attachedUnverified: zod
    .boolean()
    .optional()
    .describe(
      'True when the code completed a claim and the number is now on this account, but not verified. It cannot be made primary yet: verify it the ordinary way, starting with \/me\/phones\/resend.',
    ),
  phones: zod.array(
    zod.object({
      phoneNumber: zod.string().describe('The phone number in E.164 format'),
      primary: zod.boolean().describe('True for the primary number (the profile phone number)'),
      verified: zod.boolean().describe('True once the number has passed SMS OTP verification'),
    }),
  ),
});

export type VerifyMyPhoneResponse = zod.input<typeof VerifyMyPhoneResponse>;
export type VerifyMyPhoneResponseOutput = zod.output<typeof VerifyMyPhoneResponse>;
